// autofinance_ui_v1: หน้าระบบการเงิน (ธุรกิจ + บัญชี + รายรับจ่าย + สรุป)
import React, { useState, useEffect } from 'react';
import API from '../api';

const F = '/api/finance/businesses';
const money = function (n) { return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
/* txn_tz_fix_v2: occurred_at เป็นคอลัมน์ timestamp (ไม่มี timezone) ที่เก็บ "เวลาไทย" ตรง ๆ อยู่แล้ว
   แต่ backend ส่งกลับมาเป็น ISO ลงท้าย Z เบราว์เซอร์เลยนึกว่าเป็น UTC แล้วบวกอีก 7 ชม. ตอนแสดงผล
   จึงต้องอ่านเฉพาะตัวเลขวัน-เวลาที่เก็บไว้ แล้วแสดงตามนั้น ห้ามแปลงโซนเวลา */
const dt = function (s) {
  if (!s) return '-';
  try {
    var m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
    if (!m) return s;
    var d = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    return d.toLocaleDateString('th-TH') + ' ' + d.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
  } catch (e) { return s; }
};

const inp = { width: '100%', padding: 9, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, marginBottom: 12, boxSizing: 'border-box' };
const lbl = { fontSize: 12, color: '#64748b', fontWeight: 600 };
const btnPrimary = { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const card = { background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
// autofinance_txn_datefilter_v1: ตัวกรองวันที่ (ใช้ใน TxnTab)
function buildQS(from, to) { var p = []; if (from) p.push('from=' + encodeURIComponent(from)); if (to) p.push('to=' + encodeURIComponent(to + 'T23:59:59')); return p.length ? ('?' + p.join('&')) : ''; }
function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
/* txn_local_time_v1: คืน YYYY-MM-DDTHH:mm แบบ local (เวลาไทย) แทน UTC */
function localDt(d) { return ymd(d) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2); }
function DateFilter(props) {
  var preset = function (key) {
    var now = new Date(); var from = null, to = null;
    if (key === 'today') { from = ymd(now); to = ymd(now); }
    else if (key === '7d') { var d = new Date(now); d.setDate(d.getDate() - 6); from = ymd(d); to = ymd(now); }
    else if (key === 'month') { from = ymd(new Date(now.getFullYear(), now.getMonth(), 1)); to = ymd(now); }
    else if (key === 'year') { from = ymd(new Date(now.getFullYear(), 0, 1)); to = ymd(now); }
    props.onChange(from, to);
  };
  var bs = { padding: '6px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer', fontSize: 12 };
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
      <span style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>ช่วงวันที่:</span>
      <button onClick={function () { props.onChange(null, null); }} style={Object.assign({}, bs, (!props.from && !props.to) ? { border: '2px solid #10b981', background: '#ecfdf5', color: '#10b981', fontWeight: 600 } : {})}>ทั้งหมด</button>
      <button onClick={function () { preset('today'); }} style={bs}>วันนี้</button>
      <button onClick={function () { preset('7d'); }} style={bs}>7 วัน</button>
      <button onClick={function () { preset('month'); }} style={bs}>เดือนนี้</button>
      <button onClick={function () { preset('year'); }} style={bs}>ปีนี้</button>
      <input type="date" value={props.from || ''} onChange={function (e) { props.onChange(e.target.value || null, props.to); }} style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }} />
      <span style={{ fontSize: 12, color: '#94a3b8' }}>ถึง</span>
      <input type="date" value={props.to || ''} onChange={function (e) { props.onChange(props.from, e.target.value || null); }} style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }} />
    </div>
  );
}


function Modal(props) {
  return (
    <div onClick={props.onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 14, padding: 22, width: '100%', maxWidth: props.wide ? 520 : 400, maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, color: '#0f172a' }}>{props.title}</h3>
        {props.children}
      </div>
    </div>
  );
}

export default function BillFinance() {
  const [bizList, setBizList] = useState([]);
  const [bizId, setBizId] = useState('');
  const [tab, setTab] = useState('txn');
  const [loading, setLoading] = useState(true);
  const [myPerms, setMyPerms] = useState(null); /* autofinance_hideperm_v1 */
  useEffect(function () { API.get('/api/finance/permissions/my').then(function (r) { setMyPerms(r.data); }).catch(function () { setMyPerms({ is_owner: false, perms: {} }); }); }, []);
  /* autofinance_tabfallback_v1: รายการ tab ที่มีสิทธิ์ */
  var TAB_RES = { txn: 'transactions', summary: 'summary', accounts: 'accounts', cat: 'categories', biz: 'businesses' };
  var canSeeTab = function (k) { if (!myPerms) return false; if (myPerms.is_owner) return true; var rs = TAB_RES[k]; return !!(myPerms.perms[rs] && myPerms.perms[rs].view); };
  var allowedTabs = ['txn', 'summary', 'accounts', 'cat', 'biz'].filter(canSeeTab);
  useEffect(function () { if (myPerms && allowedTabs.length && !canSeeTab(tab)) { setTab(allowedTabs[0]); } }, [myPerms]);

  const loadBiz = function () {
    setLoading(true);
    API.get(F).then(function (r) {
      var list = r.data || [];
      setBizList(list);
      if (!bizId && list.length) setBizId(list[0].id);
    }).catch(function () { setBizList([]); }).finally(function () { setLoading(false); });
  };
  useEffect(function () { loadBiz(); }, []);

  const currentBiz = bizList.find(function (b) { return b.id === bizId; });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, margin: 0, color: '#0f172a' }}>💰 ระบบการเงิน</h1>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {/* biz_button_v1: เลือกธุรกิจเป็นปุ่ม แทน dropdown */}
          {bizList.map(function (b) {
            var activeBiz = b.id === bizId;
            return (
              <button key={b.id} onClick={function () { setBizId(b.id); }}
                style={{ padding: '8px 14px', borderRadius: 8, border: activeBiz ? 'none' : '1px solid #e2e8f0', background: activeBiz ? '#10b981' : '#f1f5f9', color: activeBiz ? '#fff' : '#475569', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>{b.name}</button>
            );
          })}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['txn', 'รายรับ-รายจ่าย', 'transactions'], ['summary', 'สรุป', 'summary'], ['accounts', 'บัญชี', 'accounts'], ['cat', 'จัดการรายการ', 'categories'], ['biz', 'จัดการธุรกิจ', 'businesses']].filter(function (t) { if (!myPerms) return false; if (myPerms.is_owner) return true; return myPerms.perms[t[2]] && myPerms.perms[t[2]].view; }).map(function (t) {
          return (
            <button key={t[0]} onClick={function () { setTab(t[0]); }}
              style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
                background: tab === t[0] ? '#10b981' : '#f1f5f9', color: tab === t[0] ? '#fff' : '#475569' }}>
              {t[1]}
            </button>
          );
        })}
      </div>

      {(loading || !myPerms) ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>
        : (allowedTabs.length === 0) ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>คุณยังไม่มีสิทธิ์เข้าถึงระบบการเงิน<br/>กรุณาติดต่อเจ้าของบัญชี</div>
        : (tab === 'biz' && canSeeTab('biz')) ? <BizTab bizList={bizList} onReload={loadBiz} onSelect={setBizId} />
        : (!bizId && canSeeTab('biz')) ? <BizTab bizList={bizList} onReload={loadBiz} onSelect={setBizId} />
        : !bizId ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>ยังไม่มีธุรกิจ</div>
        : tab === 'txn' ? <TxnTab bizId={bizId} biz={currentBiz} />
        : tab === 'summary' ? <SummaryTab bizId={bizId} />
        : tab === 'accounts' ? <AccountsTab bizId={bizId} />
        : tab === 'cat' ? <CategoryTab bizId={bizId} />
        : null}
    </div>
  );
}

// ===== Tab: จัดการธุรกิจ =====
function BizTab(props) {
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const open = function (b) { setEditing(b || null); setForm(b ? Object.assign({}, b) : { name: '' }); setErr(''); setShow(true); };
  const save = function () {
    setErr('');
    if (!form.name || !form.name.trim()) { setErr('กรุณากรอกชื่อธุรกิจ'); return; }
    setSaving(true);
    var p = editing ? API.put(F + '/' + editing.id, form) : API.post(F, form);
    p.then(function () { setShow(false); props.onReload(); })
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };
  const toggle = function (b) { API.patch(F + '/' + b.id + '/toggle').then(props.onReload).catch(function () {}); };
  const del = function (b) {
    if (!window.confirm('ลบธุรกิจ "' + b.name + '"? บัญชีและรายการทั้งหมดจะถูกลบด้วย')) return;
    API.delete(F + '/' + b.id).then(props.onReload).catch(function (e) { alert((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); });
  };

  return (
    <div>
      <div style={{ marginBottom: 12 }}><button onClick={function () { open(null); }} style={btnPrimary}>+ เพิ่มธุรกิจ</button></div>
      {props.bizList.length === 0 ? <div style={Object.assign({}, card, { textAlign: 'center', color: '#94a3b8' })}>ยังไม่มีธุรกิจ — กดเพิ่มธุรกิจเพื่อเริ่มใช้งาน</div> : (
        <div style={{ display: 'grid', gap: 10 }}>
          {props.bizList.map(function (b) {
            return (
              <div key={b.id} style={Object.assign({}, card, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 })}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15, color: '#0f172a' }}>{b.name} {!b.is_active && <span style={{ fontSize: 11, color: '#ef4444' }}>(ปิด)</span>}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>{b.tax_id ? 'เลขภาษี ' + b.tax_id : ''} {b.phone ? ' · ' + b.phone : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={function () { props.onSelect(b.id); }} style={{ background: '#ecfdf5', color: '#10b981', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>เลือก</button>
                  <button onClick={function () { open(b); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>แก้ไข</button>
                  <button onClick={function () { toggle(b); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>{b.is_active ? 'ปิด' : 'เปิด'}</button>
                  <button onClick={function () { del(b); }} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>ลบ</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {show && (
        <Modal title={editing ? 'แก้ไขธุรกิจ' : 'เพิ่มธุรกิจ'} onClose={function () { setShow(false); }} wide>
          <div style={lbl}>ชื่อธุรกิจ *</div>
          <input value={form.name || ''} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} style={inp} />
          <div style={lbl}>เลขผู้เสียภาษี</div>
          <input value={form.tax_id || ''} onChange={function (e) { setForm(Object.assign({}, form, { tax_id: e.target.value })); }} style={inp} />
          <div style={lbl}>เบอร์โทร</div>
          <input value={form.phone || ''} onChange={function (e) { setForm(Object.assign({}, form, { phone: e.target.value })); }} style={inp} />
          <div style={lbl}>อีเมล</div>
          <input value={form.email || ''} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} style={inp} />
          <div style={lbl}>ที่อยู่</div>
          <textarea value={form.address || ''} onChange={function (e) { setForm(Object.assign({}, form, { address: e.target.value })); }} style={Object.assign({}, inp, { minHeight: 60 })} />
          {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 9, borderRadius: 8, fontSize: 13, marginBottom: 10 }}>⚠️ {err}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={function () { setShow(false); }} style={{ flex: 1, padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer' }}>ยกเลิก</button>
            <button onClick={save} disabled={saving} style={Object.assign({}, btnPrimary, { flex: 1 })}>{saving ? 'บันทึก...' : 'บันทึก'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ===== Tab: รายรับ-รายจ่าย =====
function TxnTab(props) {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const [accts, setAccts] = useState([]); /* autofinance_txn_acc_v1 */
  const [employees, setEmployees] = useState([]); /* milestone_c_v1 */
  const [partners, setPartners] = useState([]); /* partner_finance_couple_v1 */
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const [dfrom, setDfrom] = useState(null);
  const [dto, setDto] = useState(null);
  const base = F + '/' + props.bizId + '/transactions';

  const load = function () {
    setLoading(true);
    API.get(base + buildQS(dfrom, dto)).then(function (r) { setRows(r.data || []); }).catch(function () { setRows([]); }).finally(function () { setLoading(false); });
    API.get(F + '/' + props.bizId + '/categories').then(function (r) { setCats((r.data || []).map(function (c) { return c.name; })); }).catch(function () {});
    API.get(F + '/' + props.bizId + '/accounts').then(function (r) { setAccts(r.data || []); }).catch(function () {}); /* autofinance_txn_acc_v1 */
  };
  useEffect(function () { load(); }, [props.bizId, dfrom, dto]); /* autofinance_txn_datefilter_v1 */
  useEffect(function () { API.get('/api/finance/employees').then(function (r) { setEmployees(r.data || []); }).catch(function () {}); }, []); /* milestone_c_v1 */
  useEffect(function () { API.get('/api/finance/partners').then(function (r) { setPartners(r.data || []); }).catch(function () {}); }, []); /* partner_finance_couple_v1 */

  const open = function (t) {
    setEditing(t || null);
    setForm(t ? Object.assign({}, t, { amount: String(t.amount) }) : { type: 'income', amount: '', category: '', note: '', occurred_at: localDt(new Date()) /* txn_local_time_v1 */, employee_id: '', kind: '', custom_label: '', balance_effect: '', partner_id: '' /* partner_finance_couple_v1 */ }); /* milestone_c_v1 */
    setErr(''); setShow(true);
  };
  const save = function () {
    setErr('');
    if (form.type !== 'income' && form.type !== 'expense') { setErr('เลือกประเภท'); return; }
    if (!form.amount || Number(form.amount) <= 0) { setErr('จำนวนเงินต้องมากกว่า 0'); return; }
    setSaving(true);
    /* milestone_c_v1: payroll coupling validation (create only) */
    if (!editing && form.employee_id) {
      if (!form.kind) { setErr('เลือกชนิดเงินเดือน'); setSaving(false); return; }
      if (form.kind === 'other') {
        if (!form.custom_label || !String(form.custom_label).trim()) { setErr('ใส่ชื่อรายการ (อื่นๆ)'); setSaving(false); return; }
        if (Number(form.balance_effect) !== 1 && Number(form.balance_effect) !== -1) { setErr('เลือกผลต่อยอด (+/−)'); setSaving(false); return; }
      }
    }
    if (!editing && form.partner_id && form.type !== 'expense') { setErr('จ่ายพาร์ทเนอร์ต้องเป็นรายจ่าย'); setSaving(false); return; } /* partner_finance_couple_v1 */
    var payload = { type: form.type, amount: Number(form.amount), category: form.category, note: form.note, occurred_at: form.occurred_at, account_id: form.account_id || null }; /* autofinance_txn_acc_v1 */
    if (!editing && form.employee_id) { /* milestone_c_v1 */
      payload.employee_id = form.employee_id;
      payload.kind = form.kind;
      if (form.kind === 'other') { payload.custom_label = String(form.custom_label).trim(); payload.balance_effect = Number(form.balance_effect); }
    }
    if (!editing && form.partner_id) { payload.partner_id = form.partner_id; } /* partner_finance_couple_v1 */
    var p = editing ? API.put(base + '/' + editing.id, payload) : API.post(base, payload);
    p.then(function () { setShow(false); load(); })
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };
  const del = function (t) {
    if (!window.confirm('ลบรายการนี้?')) return;
    API.delete(base + '/' + t.id).then(load).catch(function () {});
  };

  // running balance สะสม (ตามภาพ HYRONPAY)
  var running = 0;
  var totalIn = 0, totalOut = 0;
  rows.forEach(function (t) { if (t.type === 'income') totalIn += Number(t.amount); else totalOut += Number(t.amount); });

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <button onClick={function () { open(null); }} style={btnPrimary}>+ เพิ่มรายการ</button>
        <div style={{ flexBasis: '100%' }} />
        <DateFilter from={dfrom} to={dto} onChange={function (f, t) { setDfrom(f); setDto(t); }} />
        <div style={Object.assign({}, card, { padding: '8px 16px', display: 'flex', gap: 16, alignItems: 'center' })}>
          <span style={{ fontSize: 13, color: '#64748b' }}>รายรับ <b style={{ color: '#10b981' }}>{money(totalIn)}</b></span>
          <span style={{ fontSize: 13, color: '#64748b' }}>รายจ่าย <b style={{ color: '#ef4444' }}>{money(totalOut)}</b></span>
          <span style={{ fontSize: 13, color: '#64748b' }}>คงเหลือ <b style={{ color: (totalIn - totalOut) >= 0 ? '#10b981' : '#ef4444' }}>{money(totalIn - totalOut)}</b></span>
        </div>
      </div>
      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div> : (
        <div style={Object.assign({}, card, { padding: 0, overflowX: 'auto' })}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['#', 'รายการ', 'รายรับ', 'รายจ่าย', 'คงเหลือ', 'วันที่/เวลา', 'ผู้ลง', 'หมายเหตุ', ''].map(function (h, i) {
                  return <th key={i} style={{ padding: '10px 12px', textAlign: i >= 2 && i <= 4 ? 'right' : 'left', fontSize: 11, color: '#64748b', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? <tr><td colSpan="9" style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>ยังไม่มีรายการ</td></tr> :
                rows.map(function (t, i) {
                  running += (t.type === 'income' ? Number(t.amount) : -Number(t.amount));
                  return (
                    <tr key={t.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '10px 12px', color: '#94a3b8' }}>{i + 1}</td>
                      <td style={{ padding: '10px 12px' }}>{t.category || '-'}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', color: '#10b981', fontWeight: 600 }}>{t.type === 'income' ? money(t.amount) : ''}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', color: '#ef4444', fontWeight: 600 }}>{t.type === 'expense' ? money(t.amount) : ''}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, color: running >= 0 ? '#0f172a' : '#ef4444' }}>{money(running)}</td>
                      <td style={{ padding: '10px 12px', color: '#64748b', whiteSpace: 'nowrap' }}>{dt(t.occurred_at)}</td>
                      <td style={{ padding: '10px 12px', color: '#94a3b8' }}>{t.created_by_label || '-'}</td>
                      <td style={{ padding: '10px 12px', color: '#64748b' }}>{t.note || ''}</td>
                      <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                        <button onClick={function () { open(t); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, marginRight: 4 }}>แก้</button>
                        <button onClick={function () { del(t); }} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>ลบ</button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
      {show && (
        <Modal title={editing ? 'แก้ไขรายการ' : 'เพิ่มรายการ'} onClose={function () { setShow(false); }}>
          <div style={lbl}>ประเภท</div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4, marginBottom: 12 }}>
            {[['income', 'รายรับ', '#10b981'], ['expense', 'รายจ่าย', '#ef4444']].map(function (o) {
              return <button key={o[0]} onClick={function () { if (form.employee_id && form.kind && form.kind !== 'other') { return; } if (form.partner_id) { return; } setForm(Object.assign({}, form, { type: o[0] })); }} /* milestone_c_v1 + partner_finance_couple_v1 */
                style={{ flex: 1, padding: 10, borderRadius: 8, border: form.type === o[0] ? ('2px solid ' + o[2]) : '1px solid #e2e8f0', background: form.type === o[0] ? o[2] + '15' : '#fff', color: o[2], fontWeight: 600, cursor: 'pointer', opacity: ((form.employee_id && form.kind && form.kind !== 'other') || form.partner_id) ? 0.5 : 1 }}>{o[1]}</button>;
            })}
          </div>
          {!editing && (
            <div style={{ marginBottom: 12, padding: 12, background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
              {/* employee section — ซ่อนเมื่อเลือก partner */}
              {!form.partner_id && (
              <div>
              <div style={lbl}>ผูกพนักงาน (เงินเดือน) — ไม่บังคับ</div>
              <select value={form.employee_id || ''} onChange={function (e) { var v = e.target.value; if (!v) { setForm(Object.assign({}, form, { employee_id: '', kind: '', custom_label: '', balance_effect: '' })); } else { setForm(Object.assign({}, form, { employee_id: v })); } }} style={inp}>
                <option value="">— ไม่ผูกพนักงาน —</option>
                {employees.filter(function (e) { return e.is_active !== false; }).map(function (emp) { return <option key={emp.id} value={emp.id}>{emp.name}</option>; })}
              </select>
              {form.employee_id ? (
                <div>
                  <div style={lbl}>ชนิด</div>
                  <select value={form.kind || ''} onChange={function (e) { var k = e.target.value; var mp = { salary: 'expense', advance: 'expense', bonus: 'expense', deduction: 'income' }; var nf = Object.assign({}, form, { kind: k }); if (mp[k]) { nf.type = mp[k]; } if (k !== 'other') { nf.custom_label = ''; nf.balance_effect = ''; } setForm(nf); }} style={inp}>
                    <option value="">— เลือกชนิด —</option>
                    <option value="salary">เงินเดือน</option>
                    <option value="advance">เบิกล่วงหน้า</option>
                    <option value="bonus">โบนัส/OT</option>
                    <option value="deduction">หัก (ขาดงาน/ปกส.)</option>
                    <option value="other">อื่นๆ (กำหนดเอง)</option>
                  </select>
                  {form.kind && form.kind !== 'other' ? <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>ประเภท ({form.type === 'income' ? 'รายรับ' : 'รายจ่าย'}) ถูกกำหนดอัตโนมัติจากชนิด</div> : null}
                  {form.kind === 'other' ? (
                    <div>
                      <div style={lbl}>ชื่อรายการ</div>
                      <input value={form.custom_label || ''} onChange={function (e) { setForm(Object.assign({}, form, { custom_label: e.target.value })); }} style={inp} placeholder="เช่น เงินช่วยเหลือ" />
                      <div style={lbl}>ผลต่อยอดสะสมพนักงาน</div>
                      <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                        {[[1, 'เพิ่มยอด (+)', '#10b981'], [-1, 'ลดยอด (−)', '#ef4444']].map(function (o) {
                          return <button key={o[0]} onClick={function () { setForm(Object.assign({}, form, { balance_effect: o[0] })); }} style={{ flex: 1, padding: 9, borderRadius: 8, border: Number(form.balance_effect) === o[0] ? ('2px solid ' + o[2]) : '1px solid #e2e8f0', background: Number(form.balance_effect) === o[0] ? o[2] + '15' : '#fff', color: o[2], fontWeight: 600, cursor: 'pointer' }}>{o[1]}</button>;
                        })}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
              </div>
              )}
              {/* partner_finance_couple_v1: partner section — ซ่อนเมื่อเลือก employee */}
              {!form.employee_id && (
              <div style={{ marginTop: form.partner_id ? 0 : 10, paddingTop: form.partner_id ? 0 : 10, borderTop: form.partner_id ? 'none' : '1px dashed #e2e8f0' }}>
                <div style={lbl}>จ่ายเงินพาร์ทเนอร์ (หักค้างจ่าย) — ไม่บังคับ</div>
                <select value={form.partner_id || ''} onChange={function (e) { var v = e.target.value; if (!v) { setForm(Object.assign({}, form, { partner_id: '' })); } else { setForm(Object.assign({}, form, { partner_id: v, type: 'expense' })); } }} style={inp}>
                  <option value="">— ไม่ผูกพาร์ทเนอร์ —</option>
                  {partners.filter(function (p) { return p.is_active !== false; }).map(function (p) { return <option key={p.id} value={p.id}>{p.name}</option>; })}
                </select>
                {form.partner_id ? <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>เป็นรายจ่าย (partner เบิกเงิน) — จะหักยอดค้างจ่ายของพาร์ทเนอร์ที่หน้า "พาร์ทเนอร์"</div> : null}
              </div>
              )}
            </div>
          )}
          <div style={lbl}>รายการ</div>
          <input list="cats" value={form.category || ''} onChange={function (e) { setForm(Object.assign({}, form, { category: e.target.value })); }} style={inp} placeholder="เลือกหรือพิมพ์รายการ" />
          <datalist id="cats">{cats.map(function (c) { return <option key={c} value={c} />; })}</datalist>
          <div style={lbl}>บัญชี</div>
          <select value={form.account_id || ''} onChange={function (e) { setForm(Object.assign({}, form, { account_id: e.target.value || null })); }} style={inp}>
            <option value="">— ไม่ระบุบัญชี —</option>
            {accts.map(function (a) { return <option key={a.id} value={a.id}>{(a.account_name || a.bank_code || a.promptpay_id || 'บัญชี') + (a.account_number ? ' ' + a.account_number : '')}</option>; })}
          </select>
          <div style={lbl}>จำนวนเงิน</div>
          <input type="number" value={form.amount || ''} onChange={function (e) { setForm(Object.assign({}, form, { amount: e.target.value })); }} style={inp} />
          <div style={lbl}>วันที่/เวลา</div>
          <input type="datetime-local" value={form.occurred_at ? String(form.occurred_at).slice(0, 16) : ''} onChange={function (e) { setForm(Object.assign({}, form, { occurred_at: e.target.value })); }} style={inp} />
          <div style={lbl}>หมายเหตุ</div>
          <input value={form.note || ''} onChange={function (e) { setForm(Object.assign({}, form, { note: e.target.value })); }} style={inp} />
          {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 9, borderRadius: 8, fontSize: 13, marginBottom: 10 }}>⚠️ {err}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={function () { setShow(false); }} style={{ flex: 1, padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer' }}>ยกเลิก</button>
            <button onClick={save} disabled={saving} style={Object.assign({}, btnPrimary, { flex: 1 })}>{saving ? 'บันทึก...' : 'บันทึก'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ===== Tab: สรุป =====
/* finance_summary_v2: SummaryTab ใหม่ — DateFilter + toggle ธุรกิจ/รวม + category breakdown */
function SummaryTab(props) {
  const [mode, setMode] = useState('biz'); // 'biz' = ธุรกิจนี้ | 'all' = รวมทุกธุรกิจ
  const [dfrom, setDfrom] = useState(null);
  const [dto, setDto] = useState(null);
  const [bizData, setBizData] = useState(null);   // by-business (category rows)
  const [allData, setAllData] = useState(null);   // overview (total + businesses)
  const [loading, setLoading] = useState(true);
  const S = '/api/finance/summary';

  useEffect(function () {
    setLoading(true);
    var qs = buildQS(dfrom, dto);
    if (mode === 'biz') {
      API.get(S + '/by-business/' + props.bizId + qs).then(function (r) { setBizData(r.data); }).catch(function () { setBizData(null); }).finally(function () { setLoading(false); });
    } else {
      API.get(S + '/overview' + qs).then(function (r) { setAllData(r.data); }).catch(function () { setAllData(null); }).finally(function () { setLoading(false); });
    }
  }, [mode, props.bizId, dfrom, dto]);

  var modeBtn = function (key, label) {
    var active = mode === key;
    return <button onClick={function () { setMode(key); }} style={{ padding: '7px 14px', borderRadius: 8, border: active ? 'none' : '1px solid #e2e8f0', background: active ? '#0f172a' : '#fff', color: active ? '#fff' : '#475569', fontSize: 13, fontWeight: 600, cursor: 'pointer', marginRight: 8 }}>{label}</button>;
  };

  // รวมยอดรับ/จ่ายจาก category rows (mode biz)
  var totIncome = 0, totExpense = 0, totCount = 0;
  if (bizData && bizData.rows) {
    bizData.rows.forEach(function (c) { totIncome += Number(c.income || 0); totExpense += Number(c.expense || 0); totCount += Number(c.count || 0); });
  }

  return (
    <div>
      <div style={{ marginBottom: 12 }}>{modeBtn('biz', 'ธุรกิจนี้')}{modeBtn('all', 'รวมทุกธุรกิจ')}</div>
      <DateFilter from={dfrom} to={dto} onChange={function (f, t) { setDfrom(f); setDto(t); }} />

      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div> : (
        mode === 'biz' ? (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 16 }}>
              <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>รายรับรวม</div><div style={{ fontSize: 22, fontWeight: 700, color: '#10b981' }}>{money(totIncome)}</div></div>
              <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>รายจ่ายรวม</div><div style={{ fontSize: 22, fontWeight: 700, color: '#ef4444' }}>{money(totExpense)}</div></div>
              <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>คงเหลือ</div><div style={{ fontSize: 22, fontWeight: 700, color: (totIncome - totExpense) >= 0 ? '#10b981' : '#ef4444' }}>{money(totIncome - totExpense)}</div></div>
              <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>จำนวนรายการ</div><div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>{totCount}</div></div>
            </div>
            <div style={card}>
              <div style={{ fontWeight: 700, marginBottom: 12 }}>แยกตามรายการ{bizData && bizData.business ? ' — ' + bizData.business.name : ''}</div>
              {(!bizData || !bizData.rows || bizData.rows.length === 0) ? (
                <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>ไม่มีรายการในช่วงนี้</div>
              ) : (
                <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                  <thead><tr style={{ color: '#64748b', fontSize: 11, textAlign: 'left' }}><th style={{ padding: 8 }}>รายการ</th><th style={{ padding: 8, textAlign: 'right' }}>รับ</th><th style={{ padding: 8, textAlign: 'right' }}>จ่าย</th><th style={{ padding: 8, textAlign: 'right' }}>คงเหลือ</th></tr></thead>
                  <tbody>
                    {bizData.rows.map(function (c, i) {
                      return <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }}>
                        <td style={{ padding: 8 }}>{c.category}</td>
                        <td style={{ padding: 8, textAlign: 'right', color: '#10b981' }}>{Number(c.income) > 0 ? money(c.income) : '-'}</td>
                        <td style={{ padding: 8, textAlign: 'right', color: '#ef4444' }}>{Number(c.expense) > 0 ? money(c.expense) : '-'}</td>
                        <td style={{ padding: 8, textAlign: 'right', fontWeight: 600, color: Number(c.balance) >= 0 ? '#0f172a' : '#ef4444' }}>{money(c.balance)}</td>
                      </tr>;
                    })}
                  </tbody>
                  <tfoot><tr style={{ borderTop: '2px solid #e2e8f0', fontWeight: 700 }}><td style={{ padding: 8 }}>รวม</td><td style={{ padding: 8, textAlign: 'right', color: '#10b981' }}>{money(totIncome)}</td><td style={{ padding: 8, textAlign: 'right', color: '#ef4444' }}>{money(totExpense)}</td><td style={{ padding: 8, textAlign: 'right' }}>{money(totIncome - totExpense)}</td></tr></tfoot>
                </table>
              )}
            </div>
          </div>
        ) : (
          <div>
            {allData && allData.total ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 16 }}>
                <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>รายรับรวม (ทุกธุรกิจ)</div><div style={{ fontSize: 22, fontWeight: 700, color: '#10b981' }}>{money(allData.total.income)}</div></div>
                <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>รายจ่ายรวม (ทุกธุรกิจ)</div><div style={{ fontSize: 22, fontWeight: 700, color: '#ef4444' }}>{money(allData.total.expense)}</div></div>
                <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>คงเหลือรวม</div><div style={{ fontSize: 22, fontWeight: 700, color: allData.total.balance >= 0 ? '#10b981' : '#ef4444' }}>{money(allData.total.balance)}</div></div>
                <div style={card}><div style={{ fontSize: 12, color: '#64748b' }}>จำนวนรายการ</div><div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>{allData.total.count}</div></div>
              </div>
            ) : null}
            <div style={card}>
              <div style={{ fontWeight: 700, marginBottom: 12 }}>แยกตามธุรกิจ</div>
              {(!allData || !allData.businesses || allData.businesses.length === 0) ? (
                <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>ไม่มีข้อมูล</div>
              ) : (
                <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                  <thead><tr style={{ color: '#64748b', fontSize: 11, textAlign: 'left' }}><th style={{ padding: 8 }}>ธุรกิจ</th><th style={{ padding: 8, textAlign: 'right' }}>รับ</th><th style={{ padding: 8, textAlign: 'right' }}>จ่าย</th><th style={{ padding: 8, textAlign: 'right' }}>คงเหลือ</th></tr></thead>
                  <tbody>
                    {allData.businesses.map(function (b) {
                      return <tr key={b.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                        <td style={{ padding: 8, fontWeight: 600 }}>{b.name}</td>
                        <td style={{ padding: 8, textAlign: 'right', color: '#10b981' }}>{money(b.income)}</td>
                        <td style={{ padding: 8, textAlign: 'right', color: '#ef4444' }}>{money(b.expense)}</td>
                        <td style={{ padding: 8, textAlign: 'right', fontWeight: 600, color: b.balance >= 0 ? '#0f172a' : '#ef4444' }}>{money(b.balance)}</td>
                      </tr>;
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )
      )}
    </div>
  );
}

// ===== Tab: บัญชี ===== /* autofinance_acclabel_v1 */
// ===== Tab: จัดการรายการ (category) =====
function CategoryTab(props) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const base = F + '/' + props.bizId + '/categories';

  const load = function () {
    setLoading(true);
    API.get(base).then(function (r) { setRows(r.data || []); }).catch(function () { setRows([]); }).finally(function () { setLoading(false); });
  };
  useEffect(function () { load(); }, [props.bizId]);

  const add = function () {
    setErr('');
    if (!name.trim()) { setErr('กรุณากรอกชื่อรายการ'); return; }
    setSaving(true);
    API.post(base, { name: name.trim() })
      .then(function () { setName(''); load(); })
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'เพิ่มไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };
  const saveEdit = function (c) {
    if (!editName.trim()) return;
    API.put(base + '/' + c.id, { name: editName.trim() })
      .then(function () { setEditId(null); load(); })
      .catch(function (e) { alert((e.response && e.response.data && e.response.data.error) || 'แก้ไขไม่สำเร็จ'); });
  };
  const del = function (c) {
    if (!window.confirm('ลบรายการ "' + c.name + '"? (รายการที่ลงไปแล้วไม่หาย)')) return;
    API.delete(base + '/' + c.id).then(load).catch(function () {});
  };

  return (
    <div>
      <div style={Object.assign({}, card, { marginBottom: 12 })}>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 8 }}>เพิ่มรายการที่ใช้บ่อย เพื่อเลือกจาก dropdown ตอนลงรายรับ-รายจ่าย (ใช้ได้ทั้งรับและจ่าย)</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <input value={name} onChange={function (e) { setName(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') add(); }} style={Object.assign({}, inp, { marginBottom: 0, flex: 1 })} placeholder="เช่น ยอดฝาก, ค่าเช่า, ค่าคอม" />
          <button onClick={add} disabled={saving} style={btnPrimary}>{saving ? '...' : '+ เพิ่ม'}</button>
        </div>
        {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 9, borderRadius: 8, fontSize: 13, marginTop: 8 }}>⚠️ {err}</div>}
      </div>
      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div> :
        rows.length === 0 ? <div style={Object.assign({}, card, { textAlign: 'center', color: '#94a3b8' })}>ยังไม่มีรายการ — เพิ่มด้านบน</div> : (
          <div style={{ display: 'grid', gap: 8 }}>
            {rows.map(function (c) {
              return (
                <div key={c.id} style={Object.assign({}, card, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: 12 })}>
                  {editId === c.id ? (
                    <input value={editName} onChange={function (e) { setEditName(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') saveEdit(c); }} style={Object.assign({}, inp, { marginBottom: 0, flex: 1, marginRight: 8 })} autoFocus />
                  ) : <span style={{ fontWeight: 600, color: '#0f172a' }}>{c.name}</span>}
                  <div style={{ display: 'flex', gap: 6 }}>
                    {editId === c.id ? (
                      <React.Fragment>
                        <button onClick={function () { saveEdit(c); }} style={{ background: '#ecfdf5', color: '#10b981', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>บันทึก</button>
                        <button onClick={function () { setEditId(null); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>ยกเลิก</button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <button onClick={function () { setEditId(c.id); setEditName(c.name); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>แก้ไข</button>
                        <button onClick={function () { del(c); }} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>ลบ</button>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}

function AccountsTab(props) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false); /* account_dup_guard_v1 */
  const base = F + '/' + props.bizId + '/accounts';

  const load = function () {
    setLoading(true);
    API.get(base).then(function (r) { setRows(r.data || []); }).catch(function () { setRows([]); }).finally(function () { setLoading(false); });
  };
  useEffect(function () { load(); }, [props.bizId]);

  const open = function (a) { setEditing(a || null); setForm(a ? Object.assign({}, a) : { account_type: 'both' }); setErr(''); setShow(true); };
  const save = function () {
    if (saving) { return; } /* account_dup_guard_v1: กัน double submit */
    setErr('');
    setSaving(true);
    var p = editing ? API.put(base + '/' + editing.id, form) : API.post(base, form);
    p.then(function () { setShow(false); load(); }).catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); }).finally(function () { setSaving(false); });
  };
  const del = function (a) { if (!window.confirm('ลบบัญชีนี้?')) return; API.delete(base + '/' + a.id).then(load).catch(function () {}); };

  var typeLabel = { receive: 'รับเงิน', pay: 'จ่ายเงิน', both: 'รับ/จ่าย' };

  return (
    <div>
      <div style={{ marginBottom: 12 }}><button onClick={function () { open(null); }} style={btnPrimary}>+ เพิ่มบัญชี</button></div>
      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div> :
        rows.length === 0 ? <div style={Object.assign({}, card, { textAlign: 'center', color: '#94a3b8' })}>ยังไม่มีบัญชี</div> : (
          <div style={{ display: 'grid', gap: 10 }}>
            {rows.map(function (a) {
              return (
                <div key={a.id} style={Object.assign({}, card, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 })}>
                  <div>
                    <div style={{ fontWeight: 600, color: '#0f172a' }}>{a.account_name || a.bank_code || a.promptpay_id || 'บัญชี'} {a.is_primary && <span style={{ fontSize: 11, color: '#10b981' }}>(หลัก)</span>}{!a.is_active && <span style={{ fontSize: 11, color: '#ef4444' }}> (ปิด)</span>}</div>
                    <div style={{ fontSize: 12, color: '#94a3b8' }}>{typeLabel[a.account_type]} · {a.account_number || a.promptpay_id || ''} {a.account_name ? ' · ' + a.account_name : ''}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={function () { open(a); }} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>แก้ไข</button>
                    <button onClick={function () { del(a); }} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>ลบ</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      {show && (
        <Modal title={editing ? 'แก้ไขบัญชี' : 'เพิ่มบัญชี'} onClose={function () { setShow(false); }}>
          <div style={lbl}>ประเภท</div>
          <select value={form.account_type || 'both'} onChange={function (e) { setForm(Object.assign({}, form, { account_type: e.target.value })); }} style={inp}>
            <option value="both">รับ/จ่าย</option><option value="receive">รับเงิน</option><option value="pay">จ่ายเงิน</option>
          </select>
          <div style={lbl}>ธนาคาร</div>
          <input value={form.bank_code || ''} onChange={function (e) { setForm(Object.assign({}, form, { bank_code: e.target.value })); }} style={inp} placeholder="เช่น KBANK, SCB" />
          <div style={lbl}>เลขบัญชี</div>
          <input value={form.account_number || ''} onChange={function (e) { setForm(Object.assign({}, form, { account_number: e.target.value })); }} style={inp} />
          <div style={lbl}>ชื่อบัญชี</div>
          <input value={form.account_name || ''} onChange={function (e) { setForm(Object.assign({}, form, { account_name: e.target.value })); }} style={inp} />
          <div style={lbl}>พร้อมเพย์</div>
          <input value={form.promptpay_id || ''} onChange={function (e) { setForm(Object.assign({}, form, { promptpay_id: e.target.value })); }} style={inp} />
          {/* finance_reconcile_v1: ยอดตั้งต้น */}
          <div style={lbl}>ยอดตั้งต้น (เงินคงเหลือ ณ จุดเริ่ม/ยกมา)</div>
          <input type="number" step="0.01" value={form.opening_balance !== undefined && form.opening_balance !== null ? form.opening_balance : ''} onChange={function (e) { setForm(Object.assign({}, form, { opening_balance: e.target.value })); }} style={inp} placeholder="0" />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, cursor: 'pointer' }}>
            <input type="checkbox" checked={!!form.is_primary} onChange={function (e) { setForm(Object.assign({}, form, { is_primary: e.target.checked })); }} />
            <span style={{ fontSize: 13, color: '#475569' }}>ตั้งเป็นบัญชีหลัก</span>
          </label>
          {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 9, borderRadius: 8, fontSize: 13, marginBottom: 10 }}>⚠️ {err}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={function () { setShow(false); }} style={{ flex: 1, padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer' }}>ยกเลิก</button>
            <button onClick={save} disabled={saving} style={Object.assign({}, btnPrimary, { flex: 1, opacity: saving ? 0.6 : 1, cursor: saving ? 'wait' : 'pointer' })}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
